import { useMemo } from "react";

import {
  DEFAULT_COUNTRY,
  DEFAULT_CURRENCY,
  DEFAULT_LANGUAGE,
  DEFAULT_LOCALE,
  DEFAULT_TIMEZONE
} from "~/utils/constants";

import type { Country, Language, Currency, Locale } from "../../types";

import { type TillQueryData, useCurrentTill } from "./use-till-current";

type TillLocalisation = {
  language: Language;
  currency: Currency;
  timezone: string;
  country: Country;
  locale: Locale;
};

const DEFAULT_TILL_LOCALISATION: TillLocalisation = {
  language: DEFAULT_LANGUAGE,
  currency: DEFAULT_CURRENCY,
  timezone: DEFAULT_TIMEZONE,
  country: DEFAULT_COUNTRY,
  locale: DEFAULT_LOCALE
};

type UseCurrentTillLocalisationReturn = TillLocalisation & {
  isDefault: boolean;
};

function selectTillLocalisation(till: TillQueryData): TillLocalisation {
  return {
    language: till.language,
    currency: till.currency,
    timezone: till.timezone,
    country: till.country,
    locale: till.locale
  };
}

export function useCurrentTillLocalisation(): UseCurrentTillLocalisationReturn {
  const { data } = useCurrentTill(selectTillLocalisation);

  return useMemo(() => {
    if (data) {
      return {
        ...data,
        isDefault: false
      };
    }
    return {
      ...DEFAULT_TILL_LOCALISATION,
      isDefault: true
    };
  }, [data]);
}
